var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearchRecent = function SvgSearchRecent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M7.09 5.692A7.95 7.95 0 0 1 12 4c4.414 0 8 3.586 8 8s-3.586 8-8 8-8-3.586-8-8c0-.975.181-1.91.502-2.776l-.938-.347A9 9 0 0 0 3 12c0 4.967 4.033 9 9 9s9-4.033 9-9-4.033-9-9-9a8.95 8.95 0 0 0-5.594 1.958V3h-1v3.692h3.426v-1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#404040",
    d: "M12.5 7v5.183l2.852 2.854-.707.706-3.145-3.146V7z"
  })));
};
export default SvgSearchRecent;